import { Component, Prop, Vue } from "vue-property-decorator";
import Card from "@/components/Card.tsx";
import { CreateElement } from "vue";
import ChartTypes from "@/components/ChartTypes.tsx";

@Component
export default class TestletStatus extends Vue {
  private checkMarkUnicode = "\u2714";

  private tasks!: any;
  private processedData: any;

  private headers: any;
  private items: any;

  created() {
    this.tasks = this.$store.getters.teacherDashboard.bala.descriptions.tasks;
    let data = this.$store.getters.teacherDashboard.bala.timepoint1
      .completionStatus;
    let studentData = this.$store.getters.studentData;
    // this.data <==> 'completionStatus'
    this.processedData = [];
    Object.keys(data).forEach(studentId => {
      let studentItem: any = {
        name:
          studentData[studentId].firstname +
          " " +
          studentData[studentId].lastname
      };
      Object.keys(data[studentId]).forEach((task: any) => {
        if (task.includes("readingTask")) {
          let date = data[studentId][task].questions.status
            ? new Date(
                data[studentId][task].questions.dateCompleted
              ).toLocaleDateString()
            : "-";

          studentItem[task] = date;
        }
      });
      // for(let x=0;x<10;x++)
      this.processedData.push(studentItem);
    });

    this.headers = [{ text: "Student Name", value: "name" }];

    Object.keys(this.tasks).map((
      taskId // taskId == "readingTask1"..etc
    ) =>
      this.headers.push({
        text: this.tasks[taskId].name,
        value: taskId,
        sortable: true,
        width: "100px"
      })
    );
  }

  render(h: CreateElement) {
    return (
      <v-card>
        <v-card-title class="mx-auto text-center" style={{ paddingBottom: 0 }}>
          <span>Completion Status</span>
        </v-card-title>
        <v-card-text>
          <p>The testlets and their completion status.</p>
          <v-data-table
            headers={this.headers}
            items={this.processedData}
            items-per-page={5}
          ></v-data-table>
        </v-card-text>
      </v-card>
    );
  }
}

const component = TestletStatus;
